@use "../../styles/breakpoint.module.scss" as *;

.content {
    display: flex;
    align-items: center;

    @media ($above-tablet) {
        display: none;
    }
}

.menuToggle {
    [data-design-version="v2024"] & {
        height: 3.5em;
    }

    .toggleIcon {
        width: 1rem;
        height: 1rem;
        transform: rotate(90deg);
        transition: transform 0.2s;
    }

    &.isOpen svg {
        transform: rotate(270deg);
    }
}
